/**
* Vérificateur de codes postaux pour Jardinna.com
* Version 2.0.0
*
* Script optimisé qui vérifie si un code postal est livrable par le fournisseur
* lors de l'ajout au panier ou du passage à la caisse.
*/

(function() {
  // Variable pour éviter les doubles exécutions
  let actionInProgress = false;

  // Configuration du vérificateur
  const config = {
    // Liste des zones non livrables avec plages de codes postaux
    nonDeliverableZones: [
      // DOM-TOM
      { from: "97000", to: "97999", name: "DOM-TOM" },
      { from: "98001", to: "98999", name: "DOM-TOM" },
      
      // Corse
      { from: "20000", to: "20999", name: "Corse" },
      
      // Îles spécifiques (codes postaux individuels)
      { from: "22870", to: "22870", name: "Île de Bréhat" },
      { from: "29242", to: "29242", name: "Île d'Ouessant" },
      { from: "29253", to: "29253", name: "Île de Batz" },
      { from: "29259", to: "29259", name: "Île Molène" },
      { from: "29990", to: "29990", name: "Île de Sein" },
      { from: "56360", to: "56360", name: "Belle Île" },
      { from: "56590", to: "56590", name: "Île de Groix" },
      { from: "56780", to: "56780", name: "Île aux Moines" },
      { from: "56840", to: "56840", name: "Île d'Arz" },
      { from: "85350", to: "85350", name: "Île d'Yeu" }
    ],

    // Textes personnalisables
    texts: {
      modalTitle: "Vérification du code postal",
      modalDescription: "Veuillez entrer votre code postal pour vérifier si la livraison est possible dans votre région.",
      placeholderText: "Votre code postal",
      checkButtonText: "Vérifier",
      closeButtonText: "Fermer",
      invalidZipcodeMessage: "Veuillez entrer un code postal valide (5 chiffres).",
      nonDeliverableMessage: "Désolé, nous ne pouvons pas livrer à ce code postal. Pour plus d'informations, veuillez nous contacter.",
      deliverableMessage: "Bonne nouvelle ! Nous livrons bien à ce code postal.",
      continueButtonText: "Continuer",
      nonDeliverableMessageWithZone: "Désolé, nous ne pouvons pas livrer en {zone}. Pour plus d'informations, veuillez nous contacter."
    },

    // Options générales
    settings: {
      // Durée de validité du code postal en session (en minutes)
      sessionDuration: 60,
      
      // Toujours vérifier à chaque ajout au panier
      verifyOnEachAddToCart: false,
      
      // Toujours vérifier au passage à la caisse
      verifyOnCheckout: false,
      
      // Afficher les logs de débogage en console
      debug: false,
      
      // Afficher le nom de la zone non livrable dans le message
      showZoneNameInMessage: true
    }
  };

  // État de l'application
  const state = {
    // État de vérification
    zipCodeVerified: false,
    isDeliverable: false,
    lastCheckedZipCode: '',

    // État de l'interface
    modalCreated: false,
    modalOpen: false,

    // État du panier
    cartVerified: false,

    // Action interrompue
    pendingAction: null,

    // Initialisation
    initialized: false
  };

  // Utilitaires
  const utils = {
    // Fonction de journalisation
    log: function(message, data) {
      if (config.settings.debug) {
        console.log(`[ZipCode Checker] ${message}`, data || '');
      }
    },

    // Sélecteurs pour les boutons et formulaires
    selectors: {
      addToCart: [
        'button[name="add"]',
        '.add-to-cart',
        '.product-form__cart-submit',
        '[aria-label="Ajouter au panier"]',
        '.add_to_cart',
        'button.add-to-cart',
        'input[name="add"]',
        'button[type="submit"][name="add"]',
        'button[data-action="add-to-cart"]',
        '[data-add-to-cart]'
      ].join(', '),

      checkout: [
        'button[name="checkout"]',
        '.btn--checkout',
        '[aria-label="Acheter maintenant"]',
        '[name="checkout"]',
        '.cart__checkout',
        '.checkout-button',
        '.cart__submit',
        'input[name="checkout"]',
        'button.checkout',
        'button[type="submit"][name="checkout"]',
        'form[action*="/checkout"] button[type="submit"]',
        'form[action*="/checkout"] input[type="submit"]',
        'a[href*="/checkout"]',
        '.checkout-link',
        '[data-checkout-button]',
        // Sélecteurs spécifiques à votre thème
        '#checkout',
        '.go-checkout',
        '.go-pay',
        '.agree-checkout',
        '#mini-cart__v2 a.btn.btn-primary',
        'a.agree-checkout.go-pay',
        'button.go-checkout.go-pay'
      ].join(', ')
    }
  };

  // Interface utilisateur
  const ui = {
    // Créer la fenêtre modale
    createModal: function() {
      if (state.modalCreated) return;

      utils.log('Création de la fenêtre modale');

      // Vérifier si la modale existe déjà
      if (document.getElementById('jardinna-zipcode-modal')) {
        state.modalCreated = true;
        return;
      }

      const modal = document.createElement('div');
      modal.id = 'jardinna-zipcode-modal';
      modal.className = 'jardinna-modal';
      modal.style.display = 'none';

      const modalContent = `
        <div class="jardinna-modal-content">
          <div class="jardinna-modal-header">
            <h3>${config.texts.modalTitle}</h3>
            <button type="button" class="jardinna-modal-close" aria-label="${config.texts.closeButtonText}">&times;</button>
          </div>
          <div class="jardinna-modal-body">
            <p>${config.texts.modalDescription}</p>
            <form id="jardinna-zipcode-form">
              <div class="jardinna-form-group">
                <input type="text" id="jardinna-zipcode-input" class="jardinna-input" placeholder="${config.texts.placeholderText}" maxlength="5" pattern="[0-9]{5}" required>
                <div id="jardinna-zipcode-error" class="jardinna-error-message"></div>
              </div>
              <div class="jardinna-modal-actions">
                <button type="submit" class="jardinna-button jardinna-check-button">${config.texts.checkButtonText}</button>
              </div>
            </form>
            <div id="jardinna-zipcode-result" class="jardinna-result-message"></div>
            <div id="jardinna-continue-container" style="display: none;">
              <button type="button" id="jardinna-continue-button" class="jardinna-button jardinna-continue-button">${config.texts.continueButtonText}</button>
            </div>
          </div>
        </div>
      `;

      modal.innerHTML = modalContent;
      document.body.appendChild(modal);
      state.modalCreated = true;

      utils.log('Fenêtre modale créée');
    },

    // S'assurer que les styles CSS sont chargés
    ensureStyles: function() {
      const styleId = 'jardinna-zipcode-styles';

      // Vérifier si les styles sont déjà présents
      if (document.getElementById(styleId)) {
        return;
      }

      // Chercher la feuille de style externe
      let styleLoaded = false;
      const stylesheets = document.querySelectorAll('link[rel="stylesheet"]');
      stylesheets.forEach((sheet) => {
        if (sheet.href && sheet.href.includes('zipcode-validator.css')) {
          styleLoaded = true;
        }
      });

      // Si le style n'est pas chargé, ajouter des styles intégrés
      if (!styleLoaded) {
        utils.log('Styles CSS non détectés, ajout de styles intégrés');

        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
          .jardinna-modal {
            display: none;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 9999;
            align-items: center;
            justify-content: center;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
          }
          .jardinna-modal-content {
            background-color: #fff;
            width: 90%;
            max-width: 500px;
            border-radius: 3px;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
            position: relative;
            animation: jardinna-modal-appear 0.3s ease;
            overflow: hidden;
          }
          @keyframes jardinna-modal-appear {
            from { opacity: 0; transform: translateY(-20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .jardinna-modal-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px 20px;
            border-bottom: 1px solid #e8e9eb;
            background-color: #3a3a3a;
            color: white;
          }
          .jardinna-modal-header h3 {
            margin: 0;
            font-size: 18px;
            color: white;
          }
          .jardinna-modal-close {
            background: transparent;
            border: none;
            font-size: 24px;
            line-height: 1;
            color: white;
            cursor: pointer;
            transition: all 0.3s ease;
            padding: 0;
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .jardinna-modal-body {
            padding: 20px;
          }
          .jardinna-form-group {
            margin-bottom: 15px;
          }
          .jardinna-input {
            width: 100%;
            padding: 12px 15px;
            border: 1px solid #e8e9eb;
            border-radius: 3px;
            font-size: 16px;
            transition: all 0.3s ease;
            box-sizing: border-box;
          }
          .jardinna-button {
            padding: 12px 25px;
            font-size: 16px;
            border: none;
            border-radius: 3px;
            cursor: pointer;
            transition: all 0.3s ease;
            text-align: center;
            font-weight: 500;
            display: inline-block;
          }
          .jardinna-check-button {
            background-color: #3a3a3a;
            color: white;
          }
          .jardinna-continue-button {
            background-color: #1e9e51;
            color: white;
            margin-top: 10px;
          }
          .jardinna-modal-actions {
            display: flex;
            justify-content: flex-end;
          }
          .jardinna-error-message {
            color: #d20000;
            font-size: 14px;
            margin-top: 5px;
          }
          .jardinna-result-message {
            margin-top: 15px;
            padding: 15px;
            border-radius: 3px;
            text-align: center;
            font-weight: 500;
          }
          .jardinna-success-message {
            background-color: rgba(30, 158, 81, 0.1);
            color: #1e9e51;
            border: 1px solid rgba(30, 158, 81, 0.2);
          }
          .jardinna-error-message.jardinna-result-message {
            background-color: rgba(210, 0, 0, 0.1);
            color: #d20000;
            border: 1px solid rgba(210, 0, 0, 0.2);
          }
          #jardinna-continue-container {
            text-align: center;
            margin-top: 15px;
          }
          .jardinna-notification {
            position: fixed;
            bottom: 20px;
            right: 20px;
            max-width: 350px;
            background-color: #fff;
            border-left: 4px solid #d20000;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
            border-radius: 3px;
            z-index: 9998;
            animation: jardinna-notification-appear 0.3s ease;
          }
          @keyframes jardinna-notification-appear {
            from { opacity: 0; transform: translateX(20px); }
            to { opacity: 1; transform: translateX(0); }
          }
          .jardinna-notification-content {
            padding: 15px 40px 15px 15px;
            position: relative;
          }
          .jardinna-notification-content p {
            margin: 0;
            font-size: 14px;
            color: #3d4246;
          }
          .jardinna-notification-close {
            position: absolute;
            top: 10px;
            right: 10px;
            background: transparent;
            border: none;
            font-size: 18px;
            line-height: 1;
            color: #3d4246;
            cursor: pointer;
            transition: all 0.3s ease;
            padding: 0;
            width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          @media (max-width: 767px) {
            .jardinna-modal-content {
              width: 95%;
            }
            .jardinna-notification {
              bottom: 10px;
              right: 10px;
              left: 10px;
              max-width: none;
            }
            .jardinna-button {
              width: 100%;
            }
          }
        `;

        document.head.appendChild(style);
      }
    },
	
	// Ouvrir la fenêtre modale
    openModal: function() {
      const modal = document.getElementById('jardinna-zipcode-modal');
      if (!modal) {
        utils.log('Modale non trouvée, tentative de création');
        ui.createModal();
        setTimeout(ui.openModal, 100);
        return;
      }

      utils.log('Ouverture de la fenêtre modale');
      modal.style.display = 'flex';
      state.modalOpen = true;

      // Si un code postal a déjà été vérifié, préremplir le champ
      if (state.lastCheckedZipCode) {
        const zipcodeInput = document.getElementById('jardinna-zipcode-input');
        if (zipcodeInput) {
          zipcodeInput.value = state.lastCheckedZipCode;
        }

        // Afficher le résultat précédent si disponible
        const resultElement = document.getElementById('jardinna-zipcode-result');
        const continueContainer = document.getElementById('jardinna-continue-container');

        if (resultElement && continueContainer) {
          resultElement.textContent = state.isDeliverable ?
            config.texts.deliverableMessage :
            config.texts.nonDeliverableMessage;

          resultElement.className = 'jardinna-result-message';
          resultElement.classList.add(state.isDeliverable ?
            'jardinna-success-message' :
            'jardinna-error-message');

          continueContainer.style.display = state.isDeliverable ? 'block' : 'none';
        }
      }

      // Focus sur le champ de saisie
      setTimeout(() => {
        const zipcodeInput = document.getElementById('jardinna-zipcode-input');
        if (zipcodeInput) {
          zipcodeInput.focus();
        }
      }, 100);
    },

    // Fermer la fenêtre modale
    closeModal: function() {
      const modal = document.getElementById('jardinna-zipcode-modal');
      if (modal) {
        utils.log('Fermeture de la fenêtre modale');
        modal.style.display = 'none';
        state.modalOpen = false;
      }
    },

    // Afficher une notification
    showNotification: function(message) {
      // Supprimer toute notification existante
      const existingNotification = document.getElementById('jardinna-zipcode-notification');
      if (existingNotification) {
        existingNotification.remove();
      }

      utils.log('Affichage d\'une notification');

      const notification = document.createElement('div');
      notification.id = 'jardinna-zipcode-notification';
      notification.className = 'jardinna-notification';

      notification.innerHTML = `
        <div class="jardinna-notification-content">
          <p><strong>Attention :</strong> ${message}</p>
          <button type="button" class="jardinna-notification-close">&times;</button>
        </div>
      `;

      document.body.appendChild(notification);

      // Gestion de la fermeture
      const closeButton = notification.querySelector('.jardinna-notification-close');
      if (closeButton) {
        closeButton.addEventListener('click', function() {
          notification.remove();
        });
      }

      // Disparition automatique après 10 secondes
      setTimeout(() => {
        if (notification.parentNode) {
          notification.remove();
        }
      }, 10000);
    }
  };

  // Fonctions principales
  const app = {
    // Initialisation de l'application
    init: function() {
      if (state.initialized) return;
      
      utils.log('Initialisation du vérificateur de codes postaux');
      
      if (document.readyState === 'complete' || document.readyState === 'interactive') {
        app.initializeApp();
      } else {
        document.addEventListener('DOMContentLoaded', app.initializeApp);
        window.addEventListener('load', app.initializeApp);
      }
    },
    
    // Méthode d'initialisation réelle
    initializeApp: function() {
      if (state.initialized) return;
      
      // Créer les éléments UI
      ui.createModal();
      ui.ensureStyles();
      
      // Attacher les écouteurs d'événements
      app.attachEventListeners();
      
      // Vérifier si un code postal est en session
      app.checkSessionZipCode();
      
      state.initialized = true;
      utils.log('Initialisation réussie');
    },
    
    // Attacher les écouteurs d'événements
    attachEventListeners: function() {
      utils.log('Attachement des écouteurs d\'événements');
      
      // Gestion de la fermeture de la modale
      document.addEventListener('click', function(e) {
        if (e.target.matches('.jardinna-modal-close') || 
            (e.target.matches('#jardinna-zipcode-modal') && e.target.id === 'jardinna-zipcode-modal')) {
          ui.closeModal();
        }
        
        // Bouton Continuer
        if (e.target.id === 'jardinna-continue-button') {
          // D'abord fermer la modale
          ui.closeModal();
          
          // Exécuter l'action avec un délai
          setTimeout(app.executeAction, 500);
        }
        
        // Fermeture des notifications
        if (e.target.matches('.jardinna-notification-close')) {
          const notification = e.target.closest('.jardinna-notification');
          if (notification) {
            notification.remove();
          }
        }
      });
      
      // Formulaire de vérification du code postal
      document.addEventListener('submit', function(e) {
        if (e.target.id === 'jardinna-zipcode-form') {
          e.preventDefault();
          app.handleZipCodeFormSubmit();
        }
      });
      
      // Support pour la touche Echap
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && state.modalOpen) {
          ui.closeModal();
        }
      });
      
      // Intercepter les boutons d'ajout au panier et de paiement
      app.setupButtonInterception();
      
      // Observer les changements dans le DOM pour les nouveaux boutons
      const observer = new MutationObserver(function(mutations) {
        let hasNewButtons = false;
        
        for (const mutation of mutations) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            for (const node of mutation.addedNodes) {
              if (node.nodeType === 1) { // Élément HTML
                if ((node.matches && (node.matches(utils.selectors.addToCart) || node.matches(utils.selectors.checkout))) ||
                    (node.querySelectorAll && (node.querySelectorAll(utils.selectors.addToCart).length > 0 || 
                                              node.querySelectorAll(utils.selectors.checkout).length > 0))) {
                  hasNewButtons = true;
                  break;
                }
              }
            }
          }
        }
        
        if (hasNewButtons) {
          utils.log('Nouveaux boutons détectés, réattachement des écouteurs');
          app.setupButtonInterception();
        }
      });
      
      // Observer les changements dans le DOM
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    },
    
    // Configurer l'interception des boutons
    setupButtonInterception: function() {
      // Trouver tous les boutons actuellement dans le DOM
      const checkoutButtons = document.querySelectorAll(utils.selectors.checkout);
      const addToCartButtons = document.querySelectorAll(utils.selectors.addToCart);
      
      utils.log(`Boutons de paiement trouvés: ${checkoutButtons.length}`);
      utils.log(`Boutons d'ajout au panier trouvés: ${addToCartButtons.length}`);
      
      // Loguer les boutons de checkout trouvés pour débogage
      if (config.settings.debug) {
        checkoutButtons.forEach((button, index) => {
          utils.log(`Bouton checkout #${index}: ${button.tagName}`, {
            id: button.id,
            class: button.className,
            href: button.href,
            type: button.type,
            name: button.name,
            innerText: button.innerText.substring(0, 20) + (button.innerText.length > 20 ? '...' : '')
          });
        });
      }
      
      // Fonction d'interception pour les boutons
      // Fonction d'interception pour les boutons
			const interceptButtonClick = function(e, buttonType) {
				const element = e.currentTarget || e.target;
				
				// AJOUT: Détection spécifique du bouton "Acheter maintenant"
				if (element.id === 'addToCheckoutProduct') {
					utils.log('Bouton "Acheter maintenant" détecté - Traitement spécial');
					
					// Si le code postal a déjà été vérifié et est valide
					if (state.zipCodeVerified && state.isDeliverable) {
						// Laisser l'action se produire normalement
						return true;
					}
					
					// Sinon, interrompre et ouvrir la modale
					e.preventDefault();
					e.stopPropagation();
					
					// Enregistrer l'action en attente avec type spécifique
					state.pendingAction = {
						type: 'buynow',  // Type spécial pour Acheter maintenant
						element: element,
						buttonType: 'checkout'
					};
					
					// Ouvrir la modale
					ui.openModal();
					return false;
				}
				
				// Code existant pour les autres boutons...
				// Déterminer si on doit vérifier le code postal
				let shouldCheck = false;
				
				if (buttonType === 'checkout') {
					shouldCheck = config.settings.verifyOnCheckout || !state.isDeliverable;
				} else {
					shouldCheck = config.settings.verifyOnEachAddToCart || !state.isDeliverable;
				}
				
				if (!state.zipCodeVerified || shouldCheck) {
					e.preventDefault();
					e.stopPropagation();
					
					utils.log(`Clic sur bouton ${buttonType} intercepté`);
					
					// Enregistrer l'action en attente
					state.pendingAction = {
						type: 'element',
						element: element,
						isLink: element.tagName.toLowerCase() === 'a',
						href: element.href,
						buttonType: buttonType
					};
					
					// Ouvrir la modale
					ui.openModal();
					return false;
				}
				
				return true;
			};
      
      // Fonction d'interception pour les formulaires
      const interceptFormSubmit = function(e, formType) {
        // Vérifier si une action est déjà en cours
        if (actionInProgress) {
          utils.log('Action déjà en cours, annulation de l\'interception');
          return true;
        }
        
        // Déterminer si on doit vérifier le code postal
        let shouldCheck = false;
        
        if (formType === 'checkout') {
          shouldCheck = config.settings.verifyOnCheckout || !state.isDeliverable;
        } else {
          shouldCheck = config.settings.verifyOnEachAddToCart || !state.isDeliverable;
        }
        
        if (!state.zipCodeVerified || shouldCheck) {
          e.preventDefault();
          e.stopPropagation();
          
          utils.log(`Soumission de formulaire ${formType} interceptée`);
          
          // Enregistrer l'action en attente
          state.pendingAction = {
            type: 'form',
            element: e.currentTarget || e.target,
            formType: formType
          };
          
          // Ouvrir la modale
          ui.openModal();
          return false;
        }
        
        return true;
      };
      
      // Attacher les écouteurs aux boutons de paiement
      checkoutButtons.forEach(button => {
        if (!button.dataset.zipCodeListener) {
          button.dataset.zipCodeListener = 'checkout';
          button.addEventListener('click', function(e) {
            return interceptButtonClick(e, 'checkout');
          }, true);
        }
      });
      
      // Attacher les écouteurs aux boutons d'ajout au panier
      addToCartButtons.forEach(button => {
        if (!button.dataset.zipCodeListener) {
          button.dataset.zipCodeListener = 'addToCart';
          button.addEventListener('click', function(e) {
            return interceptButtonClick(e, 'addToCart');
          }, true);
        }
      });
      
      // Attacher les écouteurs aux formulaires d'ajout au panier
      const addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
      addToCartForms.forEach(form => {
        if (!form.dataset.zipCodeListener) {
          form.dataset.zipCodeListener = 'addToCartForm';
          form.addEventListener('submit', function(e) {
            return interceptFormSubmit(e, 'addToCart');
          }, true);
        }
      });
      
      // Attacher les écouteurs aux formulaires de paiement
      const checkoutForms = document.querySelectorAll('form[action*="/cart"], form[action*="/checkout"]');
      checkoutForms.forEach(form => {
        if (!form.dataset.zipCodeListener) {
          form.dataset.zipCodeListener = 'checkoutForm';
          form.addEventListener('submit', function(e) {
            return interceptFormSubmit(e, 'checkout');
          }, true);
        }
      });
    },
    
    // Vérifier si un code postal est déjà en session
    checkSessionZipCode: function() {
      const sessionData = sessionStorage.getItem('jardinna_zipcode_data');
      if (!sessionData) return;
      
      try {
        const data = JSON.parse(sessionData);
        const now = new Date().getTime();
        
        // Vérifier si les données sont encore valides
        if (data.expiry > now) {
          state.zipCodeVerified = true;
          state.isDeliverable = data.isDeliverable;
          state.lastCheckedZipCode = data.zipCode;
          state.cartVerified = true;
          
          utils.log(`Code postal trouvé en session: ${data.zipCode}, livrable: ${data.isDeliverable}`);
          
          // Afficher une notification si le code n'est pas livrable
          if (!state.isDeliverable) {
            ui.showNotification(config.texts.nonDeliverableMessage);
          }
        } else {
          // Données expirées
          utils.log('Données de session expirées');
          sessionStorage.removeItem('jardinna_zipcode_data');
        }
      } catch (e) {
        utils.log('Erreur lors de la lecture des données de session', e);
        sessionStorage.removeItem('jardinna_zipcode_data');
      }
    },
    
    // Sauvegarder le code postal en session
    saveZipCodeToSession: function(zipCode, isDeliverable) {
      const now = new Date().getTime();
      const expiry = now + (config.settings.sessionDuration * 60 * 1000);
      
      const data = {
        zipCode: zipCode,
        isDeliverable: isDeliverable,
        expiry: expiry
      };
      
      sessionStorage.setItem('jardinna_zipcode_data', JSON.stringify(data));
      utils.log(`Code postal enregistré en session: ${zipCode}, livrable: ${isDeliverable}`);
    },
    
    // Vérifier si un code postal est livrable
    checkZipCode: function(zipCode) {
      // Valider le format (5 chiffres en France)
      if (!/^\d{5}$/.test(zipCode)) {
        return {
          valid: false,
          message: config.texts.invalidZipcodeMessage
        };
      }
      
      // Convertir le code postal en nombre pour comparaison numérique
      const zipCodeNum = parseInt(zipCode, 10);
      
      // Vérifier si le code postal est dans une zone non livrable
      for (const zone of config.nonDeliverableZones) {
        const fromNum = parseInt(zone.from, 10);
        const toNum = parseInt(zone.to, 10);
        
        if (zipCodeNum >= fromNum && zipCodeNum <= toNum) {
          // Code postal non livrable
          let message = config.texts.nonDeliverableMessage;
          
          // Personnaliser le message avec le nom de la zone si demandé
          if (config.settings.showZoneNameInMessage) {
            message = config.texts.nonDeliverableMessageWithZone.replace("{zone}", zone.name);
          }
          
          return {
            valid: true,
            isDeliverable: false,
            message: message,
            zoneName: zone.name
          };
        }
      }
      
      // Si on arrive ici, le code postal est livrable
      return {
        valid: true,
        isDeliverable: true,
        message: config.texts.deliverableMessage
      };
    },
    
    // Gestionnaire de soumission du formulaire de vérification du code postal
    handleZipCodeFormSubmit: function() {
      utils.log('Soumission du formulaire de vérification du code postal');
      
      // Récupérer les éléments DOM
      const zipcodeInput = document.getElementById('jardinna-zipcode-input');
      const errorElement = document.getElementById('jardinna-zipcode-error');
      const resultElement = document.getElementById('jardinna-zipcode-result');
      const continueContainer = document.getElementById('jardinna-continue-container');
      
      if (!zipcodeInput || !errorElement || !resultElement || !continueContainer) {
        utils.log('Éléments DOM manquants');
        return;
      }
      
      // Récupérer le code postal saisi
      const zipCode = zipcodeInput.value.trim();
      
      // Réinitialiser les messages
      errorElement.textContent = '';
      resultElement.textContent = '';
      resultElement.className = 'jardinna-result-message';
      
      // Vérifier le code postal
      const result = app.checkZipCode(zipCode);
      
      if (!result.valid) {
        // Code postal invalide (format incorrect)
        errorElement.textContent = result.message;
        return;
      }
      
      // Mettre à jour l'état
      state.zipCodeVerified = true;
      state.isDeliverable = result.isDeliverable;
      state.lastCheckedZipCode = zipCode;
      state.cartVerified = result.isDeliverable;
      
      // Enregistrer en session
      app.saveZipCodeToSession(zipCode, result.isDeliverable);
      
      // Afficher le résultat
      resultElement.textContent = result.message;
      resultElement.classList.add(result.isDeliverable ?
        'jardinna-success-message' :
        'jardinna-error-message');
      
      // Afficher le bouton Continuer uniquement si le code est livrable
      continueContainer.style.display = result.isDeliverable ? 'block' : 'none';
    },
    
	
		// Exécuter une action en attente
    // Exécuter une action en attente
		// Exécuter une action en attente
		executeAction: function() {
			// Si aucune action en attente ou action déjà en cours
			if (!state.pendingAction || actionInProgress) {
				utils.log('Aucune action à exécuter ou action déjà en cours');
				return;
			}
			
			// Marquer comme en cours
			actionInProgress = true;
			
			utils.log(`Exécution de l'action: ${state.pendingAction.type}`, state.pendingAction);
			
			try {
				// Traitement spécial pour le bouton "Acheter maintenant"
				if (state.pendingAction.element && state.pendingAction.element.id === 'addToCheckoutProduct') {
					utils.log('Traitement spécial pour Acheter maintenant');
					
					// Trouver le formulaire parent
					const form = state.pendingAction.element.closest('form');
					if (form && form.action.includes('/cart/add')) {
						utils.log('Formulaire d\'ajout au panier trouvé, soumission via AJAX');
						
						// Créer les données du formulaire
						const formData = new FormData(form);
						
						// Ajouter au panier via AJAX puis rediriger
						fetch('/cart/add.js', {
							method: 'POST',
							body: formData
						})
						.then(response => response.json())
						.then(data => {
							utils.log('Produit ajouté au panier avec succès', data);
							
							// Attendre un moment puis rediriger vers le checkout
							setTimeout(() => {
								window.location.href = '/checkout';
							}, 300);
						})
						.catch(error => {
							utils.log('Erreur lors de l\'ajout au panier', error);
							
							// En cas d'erreur, tenter de soumettre le formulaire normalement
							if (typeof form.submit === 'function') {
								form.submit();
							}
						});
						
						return;
					} else {
						// Si nous ne trouvons pas le formulaire, rediriger directement
						utils.log('Formulaire non trouvé, redirection directe');
						window.location.href = '/checkout';
						return;
					}
				}
				
				// Traitement standard pour les autres actions
				if (state.pendingAction.type === 'element') {
					const element = state.pendingAction.element;
					
					if (state.pendingAction.isLink && state.pendingAction.href) {
						utils.log(`Navigation vers: ${state.pendingAction.href}`);
						window.location.href = state.pendingAction.href;
					} 
					else if (element && typeof element.click === 'function') {
						utils.log('Exécution du clic sur l\'élément');
						element.click();
					}
				} 
				else if (state.pendingAction.type === 'form') {
					const form = state.pendingAction.element;
					
					if (form && typeof form.submit === 'function') {
						utils.log('Soumission du formulaire');
						form.submit();
					}
				}
			} catch (e) {
				utils.log('Erreur lors de l\'exécution de l\'action', e);
			} finally {
				// Réinitialiser l'état après un délai
				setTimeout(() => {
					actionInProgress = false;
					state.pendingAction = null;
				}, 500);
			}
		}
  };
  
  // Initialiser l'application
  app.init();
})();